// removed by extract-text-webpack-plugin
module.exports = {"settings":"_1iLcqvRYO4e6HaB2ryt51i","title":"oM2V7qSjVuQl61sp8aYvy","options":"_3VW78D57ay37XbIf2XunQq","option":"_1emzTBN3Y4WQiW5Qs8kHCt"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/css/settingsScreen.css
// module id = 851
// module chunks = 0